import React, { useEffect, useState } from "react";
import { Controller, useForm } from "react-hook-form";
import Swal from "sweetalert2";
import { useLocation, useNavigate, useSearchParams } from "react-router-dom";
import { useAPIQuery } from "@dev2_techwalnut/tw-api-query-hook";
import Select from "react-select";
import secureLocalStorage from "react-secure-storage";
import { VARIABLES } from "../../Constant";

const EditMachine = () => {
    const userID = secureLocalStorage.getItem("userID");
    const delay_time = VARIABLES.delayTime;
    const navigate = useNavigate();
    const location = useLocation();
    console.log(location);
    // react Hook form Props
    const {
        register,
        handleSubmit,
        formState: { errors },
        control,
        reset,
    } = useForm();

    // select dropdown
    const [item, setItem] = useState([]);
    const [department, setDepartment] = useState([]);

    const { useFetch } = useAPIQuery({
        key: "api/generic",
        endpoint: "/api/generic/",
    });

    const { data, isLoading } = useFetch({
        abortOnNewRequest: true,
        refetchOnWindowFocus: false,
        staleTime: 1000 * 60 * 3,
        retry: 3,
        keepPlaceholder: true,
        refetchOnReconnect: true,
    });

    const { useUpdate } = useAPIQuery({
        key: "machine",
        endpoint: "/api/machine/",
    });

    const handleUpdateMachine = (data) => {
        Swal.fire({
            title: "Machine Updated!",
            text: data.message,
            icon: "success",
        }).then((result) => {
            if (result.isConfirmed) {
                setTimeout(() => {
                    navigate(-1);
                }, 2000);
            }
        });
    };

    const handleErrorMachine = (data) => {
        Swal.fire({
            title: "Error Updating Machine",
            text: data?.data?.data?.message,
            icon: "error",
        });
    };

    const { mutate, isPending } = useUpdate({
        onSuccess: handleUpdateMachine,
        onError: handleErrorMachine,
        retry: 2,
    });

    // onSubmit handler to post form details
    const onSubmit = (data) => {
        var machine = {
            machine_name: data.machine_name,
            material_type: "Asset",
            department_id: data.department.value,
            capacity: Number(data.capacity),
            // machine_status_id: data.machine_status.value,
            node_id: data.node_id,
            energy_node_id: data.energy_node_id,
            energy_slave_id: data.energy_slave_id,
            is_representative: Boolean(data.is_representative),
            updated_by: userID,
        };

        mutate({
            id: location.state.editpost.id,
            data: machine,
        });
    };

    // Pre Population of Particular Product details
    useEffect(() => {
        const editMachine = location.state.editpost;
        console.log(editMachine);
        // defaultValues is a react form hook.
        if (editMachine) {
            var defaultValues = {};
            defaultValues.machine_name = editMachine.item.item_name;
            defaultValues.wip = editMachine.wip;
            defaultValues.department = editMachine.department;
            defaultValues.capacity = editMachine.capacity;
            defaultValues.node_id = editMachine.node_id;
            defaultValues.energy_node_id = editMachine.energy_node_id;
            defaultValues.energy_slave_id = editMachine.energy_slave_id;
            defaultValues.is_representative = editMachine.is_representative;

            const getItem = {
                value: editMachine.material_type,
                label: editMachine.material_type,
            };
            defaultValues.material_type = getItem;

            const department = {
                value: editMachine.department?.id,
                label: editMachine.department?.department_name,
            };
            defaultValues.department = department;

            reset(defaultValues);
        }
    }, []);

    useEffect(() => {
        if (data) {
            setItem(
                data?.typemaster?.map((t) => ({
                    value: t?.value,
                    label: t?.name,
                    ...t,
                }))
            );
            setDepartment(data.department);
        }
    }, [data]);

    return (
        <>
            <div className="nk-block-head nk-block-head-sm">
                <div className="nk-block-between">
                    <div className="nk-block-head-content">
                        <h4 className="nk-block-title"> Edit Machine </h4>
                    </div>
                </div>
            </div>
            <div className="col-lg-12 col-md-12 col-sm-12">
                <div class="card">
                    <div class="card-inner">
                        {/* For Form : Use React hook forms */}
                        <form
                            onSubmit={handleSubmit(onSubmit)}
                            autoComplete="off"
                        >
                            <div className="row g-4">
                                <div className="col-lg-6 col-md-6 col-sm-12">
                                    <label className="form-label">
                                        Machine Name
                                        <span className="fs-8 text-danger">
                                            {" "}
                                            *
                                        </span>
                                    </label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        placeholder="Enter machine name"
                                        id="text-forms-machine_name"
                                        {...register("machine_name", {
                                            required: true,
                                        })}
                                    />
                                    {errors.wip && (
                                        <span className="fs-8 text-danger">
                                            Machine name is required
                                        </span>
                                    )}
                                </div>
                                {/* <div className="col-lg-6 col-md-6 col-sm-12">
                                    <label className="form-label">
                                        Material Type
                                        <span className="fs-8 text-danger">
                                            {" "}
                                            *
                                        </span>
                                    </label>
                                    <Controller
                                        render={({ field }) => (
                                            <Select
                                                {...field}
                                                options={item}
                                                isLoading={isLoading}
                                                isClearable={true}
                                                id="select-forms-item"
                                            />
                                        )}
                                        defaultValue=""
                                        rules={{ required: true }}
                                        name="material_type"
                                        control={control}
                                    />
                                    {errors.material_type && (
                                        <span className="fs-8 text-danger">
                                            Material Type is required
                                        </span>
                                    )}
                                </div> */}

                                <div className="col-lg-6 col-md-6 col-sm-12">
                                    <label className="form-label">
                                        Department{" "}
                                        <span className="fs-8 text-danger">
                                            {" "}
                                            *
                                        </span>
                                    </label>
                                    <Controller
                                        render={({ field }) => (
                                            <Select
                                                {...field}
                                                options={department?.map(
                                                    (api) => {
                                                        return {
                                                            value: api.id,
                                                            label: api.department_name,
                                                        };
                                                    }
                                                )}
                                                isLoading={isLoading}
                                                isClearable={true}
                                                id="select-forms-department"
                                            />
                                        )}
                                        defaultValue=""
                                        rules={{ required: true }}
                                        name="department"
                                        control={control}
                                    />
                                    {errors.department && (
                                        <span className="fs-8 text-danger">
                                            Department name is required
                                        </span>
                                    )}
                                </div>

                                <div className="col-lg-6 col-md-6 col-sm-12">
                                    <label className="form-label">
                                        Capacity (shots)
                                        <span className="fs-8 text-danger">
                                            {" "}
                                            *
                                        </span>
                                    </label>
                                    <input
                                        type="number"
                                        className="form-control"
                                        placeholder="Enter capacity of the machine"
                                        id="number-forms-capacity"
                                        {...register("capacity", {
                                            required:
                                                "Capacity of machine is required",
                                            validate: (value) => {
                                                if (value <= 0) {
                                                    return "Capacity must be greater than zero";
                                                }
                                            },
                                        })}
                                        onWheel={(e) => e.target.blur()}
                                    />
                                    {errors.capacity && (
                                        <span className="fs-8 text-danger">
                                            {errors.capacity?.message}
                                        </span>
                                    )}
                                </div>

                                {/* <div className="col-lg-6 col-md-6 col-sm-12">
                  <label className="form-label">
                    Machine Status <span className="fs-8 text-danger"> *</span>
                  </label>
                  <Controller
                    render={({ field }) => (
                      <Select
                        {...field}
                        options={machineStatus?.map((api) => {
                          return {
                            value: api.id,
                            label:
                              api.machine_status,
                          };
                        })}
                        isLoading={isLoading}
                        isClearable={true}
                        id="select-forms-machine_status"
                      />
                    )}
                    defaultValue=""
                    rules={{ required: true }}
                    name="machine_status"
                    control={control}
                  />
                  {errors.machine_status && (
                    <span className="fs-8 text-danger">
                      Machine Status is required
                    </span>
                  )}
                </div> */}

                                <div className="col-lg-6 col-md-6 col-sm-12">
                                    <label className="form-label">
                                        IO Node ID
                                        <span className="fs-8 text-danger">
                                            {" "}
                                            *
                                        </span>
                                    </label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        placeholder="Enter node id"
                                        id="text-forms-node_id"
                                        {...register("node_id", {
                                            required: true,
                                        })}
                                    />
                                    {errors.node_id && (
                                        <span className="fs-8 text-danger">
                                            Node Id is required
                                        </span>
                                    )}
                                </div>
                                <div className="col-lg-6 col-md-6 col-sm-12">
                                    <label className="form-label">Energy meter node ID</label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        placeholder="Energy / Modbus node id"
                                        {...register("energy_node_id")}
                                    />
                                </div>
                                <div className="col-lg-6 col-md-6 col-sm-12">
                                    <label className="form-label">Energy meter slave ID</label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        placeholder="Slave id"
                                        {...register("energy_slave_id")}
                                    />
                                </div>
                                <div className="col-lg-6 col-md-6 col-sm-12">
                                    <div className="custom-control custom-checkbox">
                                        <input
                                            type="checkbox"
                                            className="custom-control-input"
                                            id="is_representative"
                                            {...register("is_representative")}
                                        />
                                        <label className="custom-control-label" htmlFor="is_representative">
                                            Representative machine
                                        </label>
                                    </div>
                                </div>

                                <div className="col-12">
                                    <div className="form-group">
                                        <button
                                            type="button"
                                            className="btn btn-md btn-light me-2"
                                            id="submit-button-backbutton"
                                            onClick={() => navigate(-1)}
                                        >
                                            Back
                                        </button>
                                        {isPending ? (
                                            <button
                                                type="button"
                                                id="button-machine-loading"
                                                className="btn btn-md text-dark"
                                                disabled
                                            >
                                                Loading...
                                            </button>
                                        ) : (
                                            <button
                                                type="submit"
                                                className="btn btn-md btn-primary"
                                                id="submit-button-update-machine"
                                            >
                                                Update
                                            </button>
                                        )}
                                    </div>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </>
    );
};

export default EditMachine;
